import { generatePath } from 'react-router-dom'

export const getLink = (route: string, params: any = {}): string => {
  let updatedRoute = route
  try {
    updatedRoute = generatePath(route, params)
  } catch {
    Object.keys(params).forEach((param) => {
      updatedRoute = updatedRoute.replace(`:${param}`, params[param])
    })
  }

  return updatedRoute
}

export const getPathName = (): string => {
  return window.location.search ? window.location.pathname + window.location.search : window.location.pathname
}

export const getHostname = (): string => {
  return window.location.hostname
}

export const getOrigin = (): string => {
  return window.location.origin
}

export const getOriginFromUrl = (url: string): string => {
  const urlObject = new URL(url)
  return urlObject.origin
}

export const generateOriginPath = (pathName?: string): string => {
  return `${getOrigin()}${pathName ?? getPathName()}`
}
